import React from 'react';
import {GlobalStyles} from './components/';
import {ARMprovider} from './utils/context/context';
import Navigation from './utils/navigation/navigation';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <ARMprovider>
      <GlobalStyles />
      <BrowserRouter>
        <Navigation />
      </BrowserRouter>
    </ARMprovider>
  );
}

export default App;
